import React, { useState, useEffect } from "react";
import HeaderWithIcon from "../../components/common/HeaderWithIcon";
import { useAuth } from "../../context/AuthContext";
import { gamesApi } from "../../api/games";
import GameSettingsCard from "./GameSettingsCard";
import Button from "../../components/ui/Button";
import AddGameSettings from "../../components/Popup/AddGameSettings";
import toast from "react-hot-toast";
import { ChevronDown, ChevronUp, Plus } from "lucide-react";

export default function GameSettings() {
  const [games, setGames] = useState([]);
  const [addPopupOpen, setAddPopupOpen] = useState(false);
  const { tokens } = useAuth();

  const fetchGames = async () => {
    try {
      const response = await gamesApi.getAllGames(tokens.access.token);
      if (response.status === 200) {
        setGames(response.data);
      } else {
        toast.error("Failed to fetch games");
      }
    } catch (error) {
      console.error("Error fetching games:", error);
      toast.error("Error fetching games");
    }
  };

  useEffect(() => {
    fetchGames();
  }, [tokens.access.token]);

  return (
    <div className="min-h-screen relative overflow-hidden font-poppins">
      <HeaderWithIcon title="Game Settings" />
      
      <div className="px-5 pt-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-base font-semibold text-[#12131A]">Games</h2>
          <Button 
            text="Add Game"
            icon={Plus}
            className="px-3 py-2 bg-[#0E64D1] text-sm text-white rounded-md font-medium hover:bg-blue-700 transition-colors"
            onClick={() => setAddPopupOpen(true)}
          />
        </div>

        <div 
          className="divide-y divide-gray-200 overflow-y-auto hide-scrollbar"
          style={{ height: "calc(100vh - 150px)" }}
        >
          {games.length > 0 ? (
            games.map((game) => (
              <GameSettingsCard 
                key={game.id} 
                {...game} 
                onUpdate={fetchGames}
              />
            ))
          ) : (
            <p className="text-gray-500 text-sm text-center py-5">
              No games found. Add a new game to get started.
            </p>
          )}
        </div>
      </div>

      <AddGameSettings 
        isOpen={addPopupOpen}
        onClose={() => {
          setAddPopupOpen(false);
          // Refresh games list after adding new game
          fetchGames();
        }}
      />
    </div>
  );
}